import React, { memo } from 'react'
import { TableCell } from '@mui/material'

import Text from '../text/Text'

const TableCellData = ({
  children,
  textProps,
  sx,
  color = 'textSecondary',
  noTag = false,
  wordBreak = true,
  ...restProps
}) => {
  return (
    <TableCell
      color={color}
      {...restProps}
      sx={{ pl: '8px', pr: '8px', pt: 1.2, pb: 1.2, ...sx }}
    >
      {!noTag ? (
        <Text
          variant='h6'
          label={children}
          sx={{
            fontSize: '1rem',
            lineHeight: 1.4,
            wordBreak: wordBreak ? 'break-word' : 'keep-all'
          }}
          {...textProps}
        />
      ) : (
        children
      )}
    </TableCell>
  )
}

export default memo(TableCellData)
